import { useState } from 'react';
import { useAuth } from '@/hooks/use-auth';
import {
  LOGIN_PATH,
  takeOnboardingTarget,
  takeRedirectTarget,
} from '@/lib/redirect-after-login';

/**
 * Sair da conta, do jeito que toda tela deve sair.
 *
 * **Reload duro, e não `navigate`.** O cache do TanStack Query (sacola,
 * pedidos, catálogo) é da pessoa que estava logada; navegar dentro do SPA o
 * levaria intacto para o próximo login no mesmo dispositivo.
 *
 * O destino pós-login é descartado: se o `POST /auth/logout` voltar 401 (token
 * já expirado), o `http.ts` grava a página atual como destino — e quem
 * entrasse em seguida, talvez outra pessoa, cairia na tela de quem saiu.
 */
export function useSignOut() {
  const { logout } = useAuth();
  const [leaving, setLeaving] = useState(false);

  const signOut = async () => {
    setLeaving(true);
    try {
      await logout();
    } catch {
      // `authService.logout` já zerou o token no `finally`: localmente a
      // sessão acabou mesmo com o backend fora, e é isso que a pessoa pediu.
    }
    takeRedirectTarget();
    // E o destino do cadastro, pelo mesmo motivo: ele vive no `localStorage` e
    // sobreviveria a sair da conta — a próxima pessoa a criar conta neste
    // aparelho cairia na página de campanha que outra recebeu por WhatsApp.
    takeOnboardingTarget();
    window.location.assign(LOGIN_PATH);
  };

  return { signOut, leaving };
}
